import { Button } from './Button';
import { WifiOff, Cloud } from 'lucide-react';

export function OfflineBanner({ online, pending, syncing, onSync, labels, lastSyncError }) {
  if (!online) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-warning/30 bg-warning-bg px-4 py-3 text-sm text-warning">
        <WifiOff className="h-4 w-4 shrink-0" />
        <span className="flex-1">
          {labels.offlineSaved} — {pending} {labels.pendingSync}
          {syncing && ' …'}
        </span>
      </div>
    );
  }

  if (pending > 0) {
    return (
      <div className="flex flex-col gap-2 rounded-lg border border-primary/20 bg-primary-light px-4 py-3 text-sm text-primary">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <span className="flex items-center gap-2">
            <Cloud className="h-4 w-4" />
            {pending} {labels.pendingSync}
          </span>
          <Button variant="secondary" size="sm" onClick={() => onSync?.()} isLoading={syncing}>
            {labels.syncNow}
          </Button>
        </div>
        {lastSyncError && (
          <p className="text-xs text-danger break-words">{lastSyncError}</p>
        )}
      </div>
    );
  }

  return null;
}
